import React, { useState, useCallback, useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Row,
  Table,
} from "reactstrap";
import SwiperCore, { Autoplay } from "swiper";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { ResponseStatusEnum } from "../../utils/helpers/enums";
import { InputPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import Loader from "../../components/common/loader";
import {
  addBankDetails,
  editBankDetails,
} from "../../api/bankDetailsApi";
import { employeeProfile } from "../../api/profileApi";
import userDummyImg from "../../../src/assets/image/auth-one-bg.jpg";
import { EMPLOYEE_PROFILE_IMAGE } from "../../api/apiRoutes";
import TableContainer from "../../components/common/tableContainer";
import { getRole, getId } from "../../utils/helpers/custom";
import moment from "moment";
import { baseImageURL, baseURL } from "../../api/baseURL";
import NoResultsMessage from "../../components/noResultMessage";
import BaseButton from "../../components/BaseComponents/BaseButton";
import { checkStatusCodeSuccess, CommonLabel, dateFormat, errorHandler, ErrorImage, HandleResponse, onError, Roles } from "../../utils/helpers/common";
import BaseModal from "../../components/BaseComponents/BaseModal";
import BaseInput from "../../components/BaseComponents/BaseInput";
import { EmployeeLabels } from "../../common/constant/Employee";

const EmployeeProfile = () => {
  document.title = EmployeeLabels.EmployeeProfile;
  SwiperCore.use([Autoplay]);
  const [activityTab, setActivityTab] = useState("1");
  const [todo, setTodo] = useState(null);
  const [modalTodo, setModalTodo] = useState(false);
  const [empData , setEmpData ] = useState([])
  const [resBankDetails, setResBankDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [employeeAddressData, setEmployeeAddressData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [userDetails, setUserDetails] = useState([]);
  const [getAddress, setAddress] = useState([]);
  const [educationData, setEducationData] = useState([]);
  const [emergencyContactData, setEmergencyContactNameData] = useState([]);
  const [employeeReportToData, setEmployeeReportToData] = useState([]);
  const { emp_id } = useParams();
  const role = getRole();
  const userId = getId();
  const navigate = useNavigate();

  const toggle = useCallback(() => {
    if (modalTodo) {
      setModalTodo(false);
      setTodo(null);
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      bankName: resBankDetails === null ? "" : resBankDetails?.bankName || "",
      accountNo: resBankDetails === null ? "" : resBankDetails?.accountNo || "",
      holderName:
        resBankDetails === null ? "" : resBankDetails?.holderName || "",
      ifscCode: resBankDetails === null ? "" : resBankDetails?.ifscCode || "",
    },
    validationSchema: Yup.object({
      bankName: Yup.string().required(
        validationMessages.required(EmployeeLabels.BankName)
      ),
      accountNo: Yup.string()
        .min(8, validationMessages.minLength(EmployeeLabels.AccountNumber, 8))
        .required(validationMessages.required(EmployeeLabels.AccountNumber)),
      holderName: Yup.string().required(
        validationMessages.required(EmployeeLabels.AccountHolderName)
      ),
      ifscCode: Yup.string()
        .min(11, validationMessages.minLength(EmployeeLabels.IFSCCode, 11))
        .required(validationMessages.required(EmployeeLabels.IFSCCode)),
    }),
    onSubmit: (values) => {
      if (resBankDetails === null) {
        setLoading(true);
        addBankDetails({
          addedBy: userId,
          assignTo: emp_id,
          bankName: values.bankName,
          accountNo: values.accountNo,
          holderName: values.holderName,
          ifscCode: values.ifscCode,
        })
          .then((resp) => {
            if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
              toast.success(resp.data.message);
              viewEmployeeProfileData();
              validation.resetForm();
              toggle();
            } else {
              toast.error(resp.data.message);
            }
          })
          .catch((err) => {
            errorHandler(err);
            return err;
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        setLoading(true);
        editBankDetails(emp_id, {
          bankName: values.bankName,
          accountNo: values.accountNo,
          holderName: values.holderName,
          ifscCode: values.ifscCode,
        })
          .then((resp) => {
            if (checkStatusCodeSuccess(resp?.data?.statusCode)) {
              toast.success(resp.data.message);
              viewEmployeeProfileData();
              validation.resetForm();
              toggle();
            } else {
              toast.error(resp.data.message);
            }
          })
          .catch((err) => {
            errorHandler(err);
            return err;
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  const viewEmployeeProfileData = () => {
    setLoading(true);
    employeeProfile(emp_id)
      .then((resp) => {
        setEmpData(resp?.data?.data)
        setEmployeeData(resp?.data?.data);
        if (resp?.data?.data?.bankDetails) {
          setResBankDetails(resp?.data?.data?.bankDetails);
        } else {
          setResBankDetails(null);
        }
        if (resp?.data?.data?.userDetails) {
          setUserDetails(resp?.data?.data?.userDetails);
        } else {
          setUserDetails(null);
        }
        if (resp?.data?.data?.address) {
          setAddress(resp?.data?.data?.address);
        } else {
          setAddress(null);
        }
        if (resp?.data?.data?.educationDetails?.length === 0) {
          setEducationData([]);
        } else {
          setEducationData(resp?.data?.data?.educationDetails);
        }
        if (resp?.data?.data?.emergencyContact?.length === 0) {
          setEmergencyContactNameData(null);
        } else {
          setEmergencyContactNameData(resp?.data?.data?.emergencyContact);
        }
        if (resp?.data?.data?.address?.length === 0) {
          setEmployeeAddressData(null);
        } else {
          setEmployeeAddressData(resp?.data?.data?.reportTo);
        }
        if (resp?.data?.data?.reportTo?.length === 0) {
          setEmployeeReportToData(null);
        } else {
          setEmployeeReportToData(resp?.data?.data?.reportTo);
        }
      })
      .catch((err) => {
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns2 = useMemo(() => [
    {
      Header: EmployeeLabels.CollegeName,
      accessor: "collegeName",
      filterable: false,
    },
    {
      Header: EmployeeLabels.Qualification,
      accessor: "qualification.qualification",
      filterable: false,
    },
    {
      Header: EmployeeLabels.Year,
      accessor: "passingYear",
      filterable: false,
    },
  ]);

  useEffect(() => {
    viewEmployeeProfileData();
  }, []);

  const toggleActivityTab = (tab) => {
    if (activityTab !== tab) {
      setActivityTab(tab);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="d-flex justify-content-end mb-2">
          <BaseButton
            color="primary"
            type="button"
            onClick={() => navigate("/employee")}
            label={CommonLabel.Back}
          />
        </div>
        <Container fluid >
          <div className="profile-foreground position-relative mx-n4">
            <div className="profile-wid-bg">
              <img
                src={
                  userDetails?.profileImage !== null
                    ? `${baseImageURL}${userDetails?.profileImage}`
                    : userDummyImg
                }
                alt=""
                className="profile-wid-img"
              />
            </div>
          </div>
          {loading === false ? (
            <>
              <div className="pt-4 mb-4 mb-lg-3 pb-lg-4">
                <Row className="g-4">
                  <div className="col-auto">
                    <div className="avatar-lg">
                      <img
                        src={
                          userDetails?.profileImage !== null
                            ? `${baseImageURL}${userDetails?.profileImage}`
                            : userDummyImg
                        }
                        alt="user-img"
                        className="img-thumbnail rounded-circle h-90 w-90"
                        onError={(e) => onError(e,true)}
                      />
                    </div>
                  </div>

                  <Col>
                    <div className="p-2">
                      <p className="text-white">
                        {EmployeeLabels.EmployeeName} :{" "}
                        {employeeData?.firstName}
                      </p>
                      <p className="text-white">
                        {EmployeeLabels.EmployeeId} : {employeeData?.id}
                      </p>
                      <p className="text-white">
                        {EmployeeLabels.Role} : {employeeData?.role}
                      </p>
                      <p className="text-white">
                        {EmployeeLabels.DateOfJoining} :{" "}
                        {dateFormat(employeeData?.dateOfJoin)}
                      </p>
                      <p className="text-white">
                        {EmployeeLabels.PhoneNo} : {employeeData?.phoneNo}
                      </p>
                      <p className="text-white">
                        {EmployeeLabels.Email} : {employeeData?.email}
                      </p>
                      <p className="text-white">
                        {EmployeeLabels.ReportTo} :{" "}
                        {employeeReportToData?.firstName}{" "}
                        {employeeReportToData?.lastName}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col lg={12}>
                  <Row>
                    <Col xxl={12}>
                      <Card>
                        <CardBody>
                          <h5 className="card-title mb-3">
                            {EmployeeLabels.PersonalDetails}
                          </h5>
                          <div className="table-responsive">
                            <Table className="table-borderless mb-0">
                              <tbody>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.SkypeEmail} :
                                  </th>
                                  <td className="text-muted">
                                    {!userDetails?.skypeId
                                      ? HandleResponse.NoData
                                      : userDetails?.skypeId}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.AddressLine1} :
                                  </th>
                                  <td className="text-muted">
                                    {!getAddress?.addressLine1
                                      ? HandleResponse.NoData
                                      : getAddress?.addressLine1}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.Gender} :
                                  </th>
                                  <td className="text-muted">
                                    {!userDetails?.gender
                                      ? HandleResponse.NoData
                                      : userDetails?.gender}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.DateOfBirth} :
                                  </th>
                                  <td className="text-muted">
                                    {!userDetails?.dob
                                      ? HandleResponse.NoData
                                      : userDetails?.dob}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.Nationality} :
                                  </th>
                                  <td className="text-muted">
                                    {!userDetails?.nationality
                                      ? HandleResponse.NoData
                                      : userDetails?.nationality}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.Religion} :
                                  </th>
                                  <td className="text-muted">
                                    {!userDetails?.religion
                                      ? HandleResponse.NoData
                                      : userDetails?.religion}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xxl={12}>
                      <Card>
                        <CardBody>
                          <h5 className="card-title mb-3">
                            {EmployeeLabels.EmergencyContact}
                          </h5>
                          <div className="table-responsive">
                            <Table className="table-borderless mb-0">
                              <tbody>
                                {emergencyContactData === null ? (
                                  <NoResultsMessage />
                                ) : (
                                  emergencyContactData?.map((data, index) => {
                                    return (
                                      <>
                                        {index === 1 ? (
                                          <hr className="fullwidth"></hr>
                                        ) : (
                                          <></>
                                        )}
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            {EmployeeLabels.Name} :
                                          </th>
                                          <td className="text-muted">
                                            {emergencyContactData === null
                                              ? HandleResponse.NoData
                                              : data?.name}{" "}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            {EmployeeLabels.Relation} :
                                          </th>
                                          <td className="text-muted">
                                            {emergencyContactData === null
                                              ? HandleResponse.NoData
                                              : data?.relation}
                                          </td>
                                        </tr>
                                        <tr>
                                          <th className="ps-0" scope="row">
                                            {EmployeeLabels.PhoneNo} :
                                          </th>
                                          <td className="text-muted">
                                            {emergencyContactData === null
                                              ? HandleResponse.NoData
                                              : data?.phoneNo}
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })
                                )}
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xxl={12}>
                      <Card>
                        <CardBody>
                          <div className="d-flex align-items-center mb-4">
                            <div className="flex-grow-1">
                              <h5 className="card-title mb-0">
                                {EmployeeLabels.BankInformation}
                              </h5>
                            </div>
                            {(role === Roles.Admin || role === Roles.HR) && (
                              <div className="flex-shrink-0">
                                <BaseButton
                                  type="button"
                                  color="success"
                                  className="btn-sm"
                                  onClick={() => {
                                    setModalTodo(true);
                                  }}
                                >
                                  <i
                                    className={`${
                                      resBankDetails === null
                                        ? "ri-add-line"
                                        : "ri-pencil-line"
                                    } align-middle`}
                                  ></i>
                                </BaseButton>
                              </div>
                            )}
                          </div>
                          <div className="table-responsive">
                            <Table className="table-borderless mb-0">
                              <tbody>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.BankName} :
                                  </th>
                                  <td className="text-muted">
                                    {resBankDetails === null
                                      ? HandleResponse.NoData
                                      : resBankDetails?.bankName}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.AccountNumber} :
                                  </th>
                                  <td className="text-muted">
                                    {resBankDetails === null
                                      ? HandleResponse.NoData
                                      : resBankDetails?.accountNo}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.AccountHolderName} :
                                  </th>
                                  <td className="text-muted">
                                    {resBankDetails === null
                                      ? HandleResponse.NoData
                                      : resBankDetails?.holderName}
                                  </td>
                                </tr>
                                <tr>
                                  <th className="ps-0" scope="row">
                                    {EmployeeLabels.IFSCCode} :
                                  </th>
                                  <td className="text-muted">
                                    {resBankDetails === null
                                      ? HandleResponse.NoData
                                      : resBankDetails?.ifscCode}
                                  </td>
                                </tr>
                              </tbody>
                            </Table>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col xxl={12}>
                      <Card>
                        <CardBody>
                          <h5 className="card-title mb-3">
                            {EmployeeLabels.EducationInformation}
                          </h5>
                          {educationData?.length ? (
                            <TableContainer
                              columns={columns2}
                              data={educationData || []}
                              customPageSize={5}
                              divClass="table-responsive table-card mb-1"
                              tableClass="align-middle table-nowrap"
                              theadClass="table-light text-muted"
                            />
                          ) : (
                            <NoResultsMessage />
                          )}
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          ) : (
            <Loader />
          )}
        </Container>
        <BaseModal
          open={modalTodo}
          onClose={() => setModalTodo(false)}
          toggle={toggle}
          className="zoomIn"
          title={EmployeeLabels.BankInformation}
          bodyClassName="p-4"
          loader={loading}
          submit={validation.handleSubmit}
          submitLabel={resBankDetails ? CommonLabel.Update : CommonLabel.Add}
          submitLabelColor="primary"
          closeLabel="Cancel"
          closeLabelColor="ghost-success"
        >
          <div id="task-error-msg" className="alert alert-danger py-2"></div>
          <Form
            id="creattask-form"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <div className="mb-3">
              <BaseInput
                name="bankName"
                type="text"
                placeholder={InputPlaceHolder(EmployeeLabels.BankName)}
                label={EmployeeLabels.BankName}
                onChange={validation.handleChange}
                handleBlur={validation.handleBlur}
                value={validation.values.bankName}
                touched={validation.touched.bankName}
                error={validation.errors.bankName}
                required
              />
            </div>

            <div className="mb-3">
              <BaseInput
                name="holderName"
                type="text"
                placeholder={InputPlaceHolder(EmployeeLabels.AccountHolderName)}
                label={EmployeeLabels.AccountHolderName}
                onChange={validation.handleChange}
                handleBlur={validation.handleBlur}
                value={validation.values.holderName}
                touched={validation.touched.holderName}
                error={validation.errors.holderName}
                required
              />
            </div>

            <Row className="g-4 mb-3">
              <Col lg={6}>
                <BaseInput
                  name="accountNo"
                  type="text"
                  placeholder={InputPlaceHolder(EmployeeLabels.AccountNumber)}
                  label={EmployeeLabels.AccountNumber}
                  onChange={validation.handleChange}
                  handleBlur={validation.handleBlur}
                  value={validation.values.accountNo}
                  touched={validation.touched.accountNo}
                  error={validation.errors.accountNo}
                  required
                />
              </Col>

              <Col lg={6}>
                <BaseInput
                  name="ifscCode"
                  type="text"
                  placeholder={InputPlaceHolder(EmployeeLabels.IFSCCode)}
                  label={EmployeeLabels.IFSCCode}
                  onChange={validation.handleChange}
                  handleBlur={validation.handleBlur}
                  value={validation.values.ifscCode}
                  touched={validation.touched.ifscCode}
                  error={validation.errors.ifscCode}
                  required
                  maxLength={11}
                />
              </Col>
            </Row>
          </Form>
        </BaseModal>
      </div>
    </React.Fragment>
  );
};

export default EmployeeProfile;
